import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Dialog, DialogContent } from "../../base/dialog/dialog";
import { cn } from "../../../utils";
/**
 * Animated, two-state dialog primitive. Drops Tailwind's default `max-w-*`
 * so the inline pixel width wins; the body delegates scrolling to its inner
 * containers so the open/close zoom keyframes (which only touch transform)
 * don't fight the size transition.
 */ export const ResizableDialog = Dialog;
export const ResizableDialogContent = /*#__PURE__*/ React.forwardRef(function ResizableDialogContent({ sizes, size, transitionMs = 380, className, style, ...props }, ref) {
    const spec = sizes[size];
    if (!spec) {
        throw new Error(`ResizableDialogContent: unknown size "${size}" — known sizes: ${Object.keys(sizes).join(", ")}`);
    }
    // Transform stays on the same transition list so the modal-stack
    // depth scaling (`translate(-50%,-50%) scale(...)`) keeps animating.
    const transition = [
        `width ${transitionMs}ms var(--ease-out)`,
        `min-height ${transitionMs}ms var(--ease-out)`,
        `transform 200ms ease-in-out`
    ].join(", ");
    return /*#__PURE__*/ _jsx(DialogContent, {
        ref: ref,
        className: cn("flex flex-col gap-4 max-w-none max-h-[92vh] overflow-hidden", className),
        style: {
            width: spec.width,
            minHeight: spec.minHeight != null ? `min(${spec.minHeight}px, 92vh)` : undefined,
            transition,
            ...style
        },
        ...props
    });
});

//# sourceMappingURL=ResizableDialog.js.map